export default "__VITE_ASSET__Co$yuj9Q__"